function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M17.414 26l4.293 4.293a1 1 0 0 1-1.414 1.414l-5.647-5.646a1.5 1.5 0 0 1 0-2.122l5.647-5.646a1 1 0 0 1 1.414 1.414L17.414 24H23a7 7 0 0 0 7-7v-2a7 7 0 0 0-7-7h-1V6h1a9 9 0 0 1 9 9v2a9 9 0 0 1-9 9h-5.586zM14.586 6l-4.293-4.293A1 1 0 1 1 11.707.293l5.647 5.646a1.5 1.5 0 0 1 0 2.122l-5.647 5.646a1 1 0 0 1-1.414-1.414L14.586 8H9a7 7 0 0 0-7 7v2a7 7 0 0 0 7 7h1v2H9a9 9 0 0 1-9-9v-2a9 9 0 0 1 9-9h5.586z"
});

var SvgRebook = function SvgRebook(props) {
  return React.createElement("svg", _extends({
    width: 32,
    height: 32,
    fill: "#1B1F23",
    viewBox: "0 0 32 32"
  }, props), _ref);
};

export default __webpack_public_path__ + "20a572de8b7c202cd1130d76abca0b11.svg";
export { SvgRebook as ReactComponent };


//////////////////
// WEBPACK FOOTER
// ../icons/svg/rebook.svg
// module id = null
// module chunks = 